import { Controller, Control } from 'react-hook-form';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

interface CheckboxInputProps {
  label: string;
  name: string;
  className?: string;
  control: Control;
  required?: boolean;
  defaultValue?: boolean;
  disabledMessage?: string;
}

export default function CheckboxInput({
  label,
  name,
  className,
  control,
  required = false,
  defaultValue = false,
  disabledMessage,
}: CheckboxInputProps) {
  const fullLabel = disabledMessage ? `${label} (${disabledMessage})` : label;
  return (
    <FormControlLabel
      label={fullLabel}
      className={className}
      control={
        <Controller
          name={name as any}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <Checkbox
              color="primary"
              required={required}
              disabled={!!disabledMessage}
              onChange={(e) => field.onChange(e.target.checked)}
              checked={field.value}
            />
          )}
        />
      }
    />
  );
}
